import { Box, Text, Inline, SingleSelectButtonGroup, type SingleSelectButtonGroupProps } from '@stitch-fix/mode-react';
import { useRouter } from 'next/router';
import { CurrentLook } from '../graphql/types';
import GalleryProductCards from './GalleryProductCards';
import { UpdateLookResemblanceAnswerMutation, useUpdateLookResemblanceAnswerMutation } from '../graphql/updateLookResemblanceAnswer';
import { useToast } from '../../../../utils/contexts/toast-provider';
type OptionInfo<ValueString extends string> = SingleSelectButtonGroupProps<ValueString, {
  value: ValueString;
} & Record<string, unknown>>['options'][number];
const options: OptionInfo<'yes' | 'no'>[] = [{
  value: 'yes',
  label: 'Yes'
}, {
  value: 'no',
  label: 'No'
}] as const;
const getButtonGroupValue = (resemblesMeAnswer: boolean | null): 'yes' | 'no' | undefined => {
  if (resemblesMeAnswer === null) {
    return undefined;
  }
  return resemblesMeAnswer ? 'yes' : 'no';
};
const GalleryItemFooter = ({
  look
}: {
  look: CurrentLook;
}) => {
  const router = useRouter();
  const {
    addToast
  } = useToast();
  const [visionLookResemblanceSubmit] = useUpdateLookResemblanceAnswerMutation({
    onCompleted: (data: UpdateLookResemblanceAnswerMutation) => {
      const result = data.visionLookResemblanceSubmit?.result;
      if (result?.__typename === 'VisionLookResemblanceSubmitSuccess') {
        if (!result.look.resemblesMeAnswer) {
          router.push(`/gallery/look/${look.id}?scroll=1&returnUrl=${encodeURIComponent(router.asPath)}`);
        }
      }
      if (result?.__typename === 'VisionLookResemblanceSubmitError') {
        // eslint-disable-next-line no-console
        console.error(result.message);
        addToast({
          delay: 6000,
          status: 'error',
          message: result.message
        });
      }
    }
  });
  const updateLookResemblanceAnswer = (value: string) => {
    const resemblesMeAnswer = value === 'yes';
    visionLookResemblanceSubmit({
      variables: {
        input: {
          lookId: look.id,
          resemblesMeAnswer
        }
      },
      optimisticResponse: {
        visionLookResemblanceSubmit: {
          __typename: 'VisionLookResemblanceSubmitPayload',
          result: {
            __typename: 'VisionLookResemblanceSubmitSuccess',
            look: {
              __typename: 'Look',
              id: look.id,
              resemblesMeAnswer
            }
          }
        }
      }
    });
  };
  const buttonGroupValue = getButtonGroupValue(look.resemblesMeAnswer ?? null);
  return <>
      <GalleryProductCards look={look} />
      <Box mt={1} as="section">
        <Text color="blue-45" setting="body-large-fixed">
          Do you like this image?
        </Text>
        <Inline spacing={1} mt={0.5}>
          <SingleSelectButtonGroup name={`look-resemblance-${look.id}`} options={options} value={buttonGroupValue} onChange={updateLookResemblanceAnswer} variant="pill" optionMinWidth="4rem" />
        </Inline>
      </Box>
    </>;
};
export default GalleryItemFooter;